import { ModalTitle } from '@tryhackme/thm-ui-components';
import styled from 'styled-components';

export const StyledModalTitle = styled(ModalTitle)`
  color: ${({ theme }) => theme.colors.text.main};
  margin-bottom: 2rem;
`;
